import { feedServer } from "@/http";

export default {
    async likePost(context, payload) {
        const response = await feedServer.post(`/likes/${payload.postId}`, {}, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (response.status !== 201) {
            throw new Error(response.message);
        }
        context.commit("setToggleLikePost", payload);
    },
    async fetchAllUserLikePost(context, payload) {
        const postIds = {
            post_ids: payload.postIds
        }
        const response = await feedServer.post('/likes/users', JSON.stringify(postIds), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (response.status !== 200) {
            throw new Error(response.message);
        }
        context.commit("setAllUserLikePost", response.data);
    },
    async fetchAllLikePost(context, payload) {
        const postIds = {
            post_ids: payload.postIds
        }
        const response = await feedServer.post('/likes/posts', JSON.stringify(postIds), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (response.status !== 200) {
            throw new Error(response.message);
        }
        context.commit("setPostLikes", response.data);
    },
    async fetchSpecificUserLikePost(context, payload) {
        const postIds = {
            post_ids: payload.postIds
        }
        const userId = localStorage.getItem('userId');
        const response = await feedServer.post(`/likes/users/${userId}`, JSON.stringify(postIds), {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('token')
            }
        });
        if (response.status !== 200) {
            throw new Error(response.message);
        }

        context.commit("setSpecificUserLikePost", response.data);
    }
};
